/**
 * @generated SignedSource<<79de48963ca3bfdf0340a3932b6e9852>>
 * @relayHash b86c23d36081ccce56a4c4c88f1c5af9
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b86c23d36081ccce56a4c4c88f1c5af9

import { ConcreteRequest } from 'relay-runtime';
export type deSigningSubscription$variables = {
  signRequestId: string;
};
export type deSigningSubscription$data = {
  readonly de_documentSigned: {
    readonly documentId: string;
    readonly signRequestId: string;
    readonly signedAt: string;
    readonly signedBy: string;
  };
};
export type deSigningSubscription = {
  response: deSigningSubscription$data;
  variables: deSigningSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "signRequestId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "signRequestId",
        "variableName": "signRequestId"
      }
    ],
    "concreteType": "DocumentSignedMessage",
    "kind": "LinkedField",
    "name": "de_documentSigned",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "documentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signedBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signRequestId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deSigningSubscription",
    "selections": (v1/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deSigningSubscription",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "b86c23d36081ccce56a4c4c88f1c5af9",
    "metadata": {},
    "name": "deSigningSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "7d928a8a26adf0cdaa2c45d3b1eb8a9d";

export default node;
